import { render, staticRenderFns } from "./SuperUserFunctionsComponent.vue?vue&type=template&id=77f4ac94&scoped=true&"
import script from "./SuperUserFunctionsComponent.vue?vue&type=script&lang=js&"
export * from "./SuperUserFunctionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4ac94",
  null
  
)

export default component.exports